@if (authenticating) {
  <div class="auth-container">
    <h5>Authenticating</h5>
    <div class="loading-dot-wrapper">
      <app-loading-dots dotColor="white"></app-loading-dots>
    </div>
  </div>
} @else {
  <div class="auth-container">
    <h5>An error occurred while authenticating. If the issue persists report it to Contact Center Technology.</h5>
  </div>
}
